import {initCollection} from './form_collection';
import {appQuery} from './utils_request';
import {createAlert, createBadge, createButton, createElement, removeAllChild} from './utils_element';
import moment from 'moment/moment';

const feedback = document.getElementById('feedback');
const status = document.getElementById('status');
const saleHoursCollectionId = 'sale_with_template_sale_w3CVENTELIGNECollection';

let autocertiLogoUrl = '';
let sale = {};
let vehicles = [];
let isInitSendAutocerti = false;
let isInitImportLeasePlan = false;
const WEB_SALE_TYPE_LABEL = 'Electronique';

export const init = (saleJson, autocertiUrl, vehiclesJson, withCollection = true) => {
    autocertiLogoUrl = autocertiUrl;

    if (saleJson !== 'new') {
        setSale(saleJson);
        setVehicles(vehiclesJson)
        initSendAutocerti();
        initExportInterencheres();
        initImportLeasePlan();
        initStatus();
    } else {
        sale = saleJson;
    }

    if (withCollection) {
        initCollection(saleHoursCollectionId);
        preventRemoveSaleHourWithVehicles();
    }

    handleDatePicker();
}

const setSale = (saleJson) => {
    sale = JSON.parse(saleJson);
}

const setVehicles = (vehiclesJson) => {
    vehicles = JSON.parse(vehiclesJson);
}

const preventRemoveSaleHourWithVehicles = () => {
    let lineIdInputs = document.querySelectorAll('.lineId'),
        lineIdsVehicles = vehicles.map(vehicle => vehicle['LineIdVenteHeure']);

    for (let i = 0; i < lineIdInputs.length; i++) {
        if (lineIdsVehicles.includes(parseInt(lineIdInputs[i].value))) {
            let btnRemove = lineIdInputs[i].parentElement.querySelector('.btn');
            btnRemove.remove();
            let newButton = createButton(
                'btn text-danger bg-light btn-outline-gray-2 px-2 border-left-0 rounded-right',
                '',
                'fa fa-times'
            );
            newButton.setAttribute('type', 'button');
            $(newButton).tooltip({title: 'Impossible de supprimer cette heure de vente. Des véhicules sont liés.'});
            lineIdInputs[i].parentElement.append(newButton);
        }
    }
}

const initStatus = () => {
    switch (sale['U_W3C_TRLP']) {
        case 'TODO':
            removeIfExist(status, '#leasePlanStatus');
            status.append(createBadge('info', 'Import LeasePlan en attente de traitement', 'leasePlanStatus'))
            break;
        case 'IN_PROGRESS':
            removeIfExist(status, '#leasePlanStatus');
            status.append(createBadge('primary', 'Import LeasePlan en cours de traitement', 'leasePlanStatus'))
            break;
        case 'COMPLETED':
            removeIfExist(status, '#leasePlanStatus');
            status.append(createBadge('success', 'Import LeasePlan effectué', 'leasePlanStatus'))
            break;
        case 'ERROR':
            removeIfExist(status, '#leasePlanStatus');
            status.append(
                createBadge(
                    'danger',
                    'Erreur détectée lors de l\'import des véhicules LeasePlan, veuillez réitérer l\'action, si le problème persiste, contactez le support.',
                    'leasePlanStatus'
                )
            )
            break;
    }

    if (sale['U_W3C_VTPF'] === 'Y') {
        removeIfExist(status, '#autocertiStatus');
        status.append(createBadge('success', 'Envoyée sur pro.enchères-vo.com', 'autocertiStatus'))
    }
}

const removeIfExist = (HTMLElement, selector) => {
    if (HTMLElement.querySelector(selector)) {
        HTMLElement.querySelector(selector).remove()
    }
}

const initExportInterencheres= () => {
    const btn = document.getElementById('exportInterEncheres');

    btn.addEventListener('click', () => {
        let exportInterEncheresIcon = $('#exportInterEncheresIcon');
        exportInterEncheresIcon.replaceWith("<i id=\"export-interencheres-loader\" class=\"fa fa-spinner fa-pulse mr-2 text-dark\"></i>");

        if (!sale['DocEntry']) {
            removeIfExist(feedback, '.alert');
            feedback.append(
                createAlert('danger', 'Veuillez enregistrer la vente avant de l\'envoyer sur InterEncheres.')
            );

            return;
        }

        btn.disabled = true;

        appQuery(urls.interencheresExportSale.replace('toRpDocEntryVente', sale['DocEntry']))
            .then(resp => {
                let exportInterEncheresLoader = $('#export-interencheres-loader');
                exportInterEncheresLoader.replaceWith("<i id=\"exportInterEncheresIcon\" class=\"fad fa-file-export mr-2 text-dark\"></i>");

                btn.disabled = false;
                removeAllChild(feedback);
                if (status.querySelector('#interencheresStatus')) {
                    status.querySelector('#interencheresStatus').remove()
                }
                if (resp.valid) {
                    status.append(
                        createBadge('success', 'Envoyée sur InterEncheres', 'interencheresStatus')
                    )
                } else {
                    status.append(
                        createBadge('danger', 'Echec de l\'envoi sur InterEncheres : ' + resp.error, 'interencheresStatus')
                    )
                }
            })
    });
}

const initSendAutocerti = () => {
    const btn = document.getElementById('send-autocerti');

    if (isInitSendAutocerti || !btn) return;

    btn.addEventListener('click', () => {
        let sendAutocertiIcon = $('#send-autocerti-icon');
        sendAutocertiIcon.replaceWith("<i id=\"send-autocerti-loader\" class=\"fa fa-spinner fa-pulse mr-2 text-dark\"></i>");

        if (!sale['DocEntry']) {
            removeIfExist(feedback, '.alert');
            feedback.append(
                createAlert('danger', 'Veuillez enregistrer la vente avant de l\'envoyer sur pro.enchères-vo.com.')
            );

            return;
        }

        btn.disabled = true;

        appQuery(urls.autocertiSendSale.replace('toRpDocEntryVente', sale['DocEntry']))
            .then(resp => {
                let sendAutocertiLoader = $('#send-autocerti-loader');
                sendAutocertiLoader.replaceWith("<i id=\"send-autocerti-icon\" class=\"fad fas fa-redo mr-2 text-dark\"></i>");

                btn.disabled = false;
                if (resp.valid) {
                    removeAllChild(feedback);

                    if (status.querySelector('#autocertiStatus')) {
                        status.querySelector('#autocertiStatus').remove()
                    }

                    status.append(
                        createBadge('success', 'Envoyée sur pro.enchères-vo.com', 'autocertiStatus')
                    )
                } else {
                    Object.keys(resp.errors).forEach(key => {
                        let selector = '[name="sale_with_template[sale][' + key + ']"]',
                            concernedInput = document.querySelector(selector),
                            invalidFeedback = createElement('div', 'invalid-feedback');

                        invalidFeedback.innerText = resp.errors[key];

                        if (key === 'feedback') {
                            removeIfExist(feedback, '.alert');
                            feedback.append(
                                createAlert('danger', resp.errors[key], 'fad fa-exclamation-triangle mr-2')
                            );
                            return;
                        }

                        // TODO : refactor this TODO comment below because it makes no sense.
                        // TODO refactoring merge this code with
                        if (key.includes('heure')) {
                            let selectors = ['[name="sale_with_template[sale][' + key + '][hour]"]', '[name="sale_with_template[sale][' + key + '][minute]"]'];
                            let hourInput = document.querySelector(selectors[0]);
                            let minuteInput = document.querySelector(selectors[1]);

                            hourInput.classList.add('is-invalid');
                            minuteInput.classList.add('is-invalid');

                            if (hourInput.parentElement.querySelector('.invalid-feedback') !== null) {
                                hourInput.parentElement.querySelector('.invalid-feedback').remove();
                            }

                            hourInput.parentElement.append(invalidFeedback);

                            return;
                        }

                        concernedInput.classList.add('is-invalid');

                        if (concernedInput.parentElement.querySelector('.invalid-feedback') !== null) {
                            concernedInput.parentElement.querySelector('.invalid-feedback').remove();
                        }

                        concernedInput.parentElement.append(invalidFeedback);
                    });
                }
            })
    });

    isInitSendAutocerti = true;
}

const initImportLeasePlan = () => {
    const btn = document.getElementById('importLeasePlan')
    // No btn action when is not leasePlan or leasePlanTraitement is set to TODO
    if (!btn || isInitImportLeasePlan) {
        return
    }

    btn.addEventListener('click', () => {
        btn.disabled = true;
        appQuery(urls.setImportLeasePlan.replace('toRpDocEntry', sale['DocEntry']))
            .then(resp => {
                if (status.querySelector('#leasePlanStatus')) {
                    status.querySelector('#leasePlanStatus').remove()
                }
                if (resp.valid) {
                    btn.remove()
                    status.append(
                        createBadge('info', 'Import LeasePlan en attente de traitement', 'leasePlanStatus')
                    )
                } else {
                    btn.disabled = false;
                    feedback.append(
                        createBadge('danger', 'Impossible d\'importer les véhicules LeasePlan.', 'leasePlanStatus')
                    )
                }
            })
    });

    isInitImportLeasePlan = true;
};

const initSelectLogo = () => {
    const selectLogo = document.getElementById('sale_with_template_sale_logoDeLaVente');
    const logoContainer = document.getElementById('electronic-sale-logo');

    const addLogo = (code) => {
        if (code === '') {
            logoContainer.querySelector('img').classList.add('d-none');
            logoContainer.querySelector('svg').classList.remove('d-none');

            return;
        }

        logoContainer.querySelector('img').src =
            autocertiLogoUrl
                .replace('{code}', code)
                .replace('{code}', code)
        ;

        logoContainer.querySelector('svg').classList.add('d-none');
        logoContainer.querySelector('img').classList.remove('d-none');
    }

    if (selectLogo) {
        selectLogo.addEventListener('change', (e) => {
            addLogo(e.target.value)
        });

        if (selectLogo.value) {
            addLogo(selectLogo.value);
        }
    }
}

global.initDataTableForSale = function () {
    $('#sale-data-table').DataTable({
        lengthMenu: [[50, 100, 150, -1], [50, 100, 150, "Tout"]],
        pageLength: 100,
        language: {
            info: "V&eacute;hicules _START_ &agrave; _END_ sur _TOTAL_",
            lengthMenu: "Afficher _MENU_ v&eacute;hicules",
            search: "Rechercher",
            processing: "Chargement...",
            paginate: {
                previous: "Pr&eacute;c&eacute;dent",
                next: "Suivant",
            },
        },
    });
};

global.saleFormDynamic = () => {
    let saleTypeSelect = $('#sale_with_template_sale_venteClassiqueOuElectronique');
    let electronicSpecificFields = $('.electronic-specific-fields');
    let physicalSpecificFields = $('.physical-specific-fields');
    let submitSaleButton = $('#sale_with_template_submit_sale');

    electronicSpecificFields.each((index, element) => {
        if (saleTypeSelect.val() === WEB_SALE_TYPE_LABEL) {
            $(element).removeClass('d-none');
            initSelectLogo();
        } else {
            $(element).addClass('d-none');
        }

        saleTypeSelect.on('change', e => {
            if (e.target.value === WEB_SALE_TYPE_LABEL) {
                $(element).fadeIn(() => {
                    $(element).removeClass('d-none');
                });
                initSelectLogo();
            } else {
                $(element).fadeOut(() => {
                    $(element).addClass('d-none');
                });
            }
        });
    })

    physicalSpecificFields.each((index, element) => {
        if (saleTypeSelect.val() !== WEB_SALE_TYPE_LABEL) {
            $(element).removeClass('d-none');
            initSelectLogo();
        } else {
            $(element).addClass('d-none');
        }

        saleTypeSelect.on('change', e => {
            if (e.target.value !== WEB_SALE_TYPE_LABEL) {
                $(element).fadeIn(() => {
                    $(element).removeClass('d-none');
                });
                initSelectLogo();
            } else {
                $(element).fadeOut(() => {
                    $(element).addClass('d-none');
                });
            }
        });
    })

    // Just to beautify an ugly behavior when the submit button is clicked.
    submitSaleButton.on('click', () => {
        submitSaleButton.prev().addClass('rounded-right');
    });
};

global.handleTransformedSaleInput = () => {
    let saleTypeSelect = $('#sale_with_template_sale_venteClassiqueOuElectronique');
    let exhibitionStartDateSaleInput = $('#sale_with_template_sale_expositionDebutLe');
    let exhibitionStartInput = $('#sale_with_template_sale_elecheuredebutexpo');
    let exhibitionStartHourInput = $('#sale_with_template_sale_elecheuredebutexpo_hour');
    let exhibitionStartMinuteInput = $('#sale_with_template_sale_elecheuredebutexpo_minute');
    let exhibitionEndInput = $('#row_sale_with_template_sale_elecheurefinexpo');
    let exhibitionEndHourInput = $('#sale_with_template_sale_elecheurefinexpo_hour');
    let exhibitionEndMinuteInput = $('#sale_with_template_sale_elecheurefinexpo_minute');
    let exhibitionEndDateSaleInput = $('#sale_with_template_sale_expositionFinLe');

    // On sale creation
    saleTypeSelect.on('blur', () => {
        if (exhibitionStartInput.length === 0) {
            exhibitionStartInput = $('#sale_with_template_sale_elecheuredebutexpo');
            exhibitionStartHourInput = $('#sale_with_template_sale_elecheuredebutexpo_hour');
            exhibitionStartMinuteInput = $('#sale_with_template_sale_elecheuredebutexpo_minute');
            exhibitionStartDateSaleInput = $('#sale_with_template_sale_expositionDebutLe');
        }

        if (exhibitionEndInput.length === 0) {
            exhibitionEndInput = $('#row_sale_with_template_sale_elecheurefinexpo');
            exhibitionEndHourInput = $('#sale_with_template_sale_elecheurefinexpo_hour');
            exhibitionEndMinuteInput = $('#sale_with_template_sale_elecheurefinexpo_minute');
            exhibitionEndDateSaleInput = $('#sale_with_template_sale_expositionFinLe');
        }

        handleExhibitionDateEvent(
            exhibitionStartDateSaleInput,
            exhibitionStartInput,
            exhibitionStartHourInput,
            exhibitionStartMinuteInput,
            exhibitionEndInput,
            exhibitionEndHourInput,
            exhibitionEndMinuteInput,
            exhibitionEndDateSaleInput,
        )
    })

    handleExhibitionDateEvent(
        exhibitionStartDateSaleInput,
        exhibitionStartInput,
        exhibitionStartHourInput,
        exhibitionStartMinuteInput,
        exhibitionEndInput,
        exhibitionEndHourInput,
        exhibitionEndMinuteInput,
        exhibitionEndDateSaleInput,
    )
}

const handleExhibitionDateEvent = (
    exhibitionStartDateSaleInput,
    exhibitionStartInput,
    exhibitionStartHourInput,
    exhibitionStartMinuteInput,
    exhibitionEndInput,
    exhibitionEndHourInput,
    exhibitionEndMinuteInput,
    exhibitionEndDateSaleInput,
) => {
    let startDateTime = moment();
    let endDateTime = moment();

    if (exhibitionStartDateSaleInput.val()) {
        let value = exhibitionStartDateSaleInput.val()
        startDateTime = moment(value.substring(6, 10)+'-'+value.substring(3, 5)+'-'+value.substring(0, 2));
        startDateTime
            .hours(parseInt(exhibitionStartHourInput.val()))
            .minutes(parseInt(exhibitionStartMinuteInput.val()))
            .seconds(0)
            .milliseconds(0)
        ;
    }

    if (exhibitionEndDateSaleInput.val()) {
        let value = exhibitionEndDateSaleInput.val()
        endDateTime = moment(value.substring(6, 10)+'-'+value.substring(3, 5)+'-'+value.substring(0, 2));
        endDateTime
            .hours(parseInt(exhibitionEndHourInput.val()))
            .minutes(parseInt(exhibitionEndMinuteInput.val()))
            .seconds(0)
            .milliseconds(0)
        ;
    }

    handleTransformedSaleInputClass(startDateTime, endDateTime);

    exhibitionStartDateSaleInput.on('blur', () => {
        let value = exhibitionStartDateSaleInput.val()
        startDateTime = moment(value.substring(6, 10)+'-'+value.substring(3, 5)+'-'+value.substring(0, 2));
        startDateTime.hours(parseInt(exhibitionStartHourInput.val())).minutes(parseInt(exhibitionStartMinuteInput.val()));

        handleTransformedSaleInputClass(startDateTime, endDateTime);
    });

    exhibitionEndDateSaleInput.on('blur', () => {
        let value = exhibitionEndDateSaleInput.val()
        endDateTime = moment(value.substring(6, 10)+'-'+value.substring(3, 5)+'-'+value.substring(0, 2));
        endDateTime.hours(parseInt(exhibitionEndHourInput.val())).minutes(parseInt(exhibitionEndMinuteInput.val()));

        handleTransformedSaleInputClass(startDateTime, endDateTime);
    });

    exhibitionStartInput.on('change', () => {
        startDateTime
            .hours(parseInt(exhibitionStartHourInput.val()))
            .minutes(parseInt(exhibitionStartMinuteInput.val()))
            .seconds(0)
            .milliseconds(0)
        ;

        handleTransformedSaleInputClass(startDateTime, endDateTime);
    });

    exhibitionEndInput.on('change', () => {
        endDateTime
            .hours(parseInt(exhibitionEndHourInput.val()))
            .minutes(parseInt(exhibitionEndMinuteInput.val()))
            .seconds(0)
            .milliseconds(0)
        ;

        handleTransformedSaleInputClass(startDateTime, endDateTime);
    });
}

const handleTransformedSaleInputClass = (startDateTime, endDateTime) => {
    let transformedSaleDiv = $('#sale_with_template_sale_minuteDeclenchementVenteTransformee').parent().parent();

    if (endDateTime.format('X') - startDateTime.format('X') === 60) {
        transformedSaleDiv.removeClass('d-none');
    } else {
        transformedSaleDiv.addClass('d-none');
    }
}

global.handleSalesRoomInput = () => {
    let socialNameSelect = $('#sale_with_template_sale_whscode');

    socialNameSelect.change(function() {
        saleroomAjax(socialNameSelect);
    });

    // Triggered once at the page init.
    saleroomAjax(socialNameSelect);
}

global.handleSocialNameInput = () => {
    let saleTypeSelect = $('#sale_with_template_sale_venteClassiqueOuElectronique');
    let socialNameSelect = $('#sale_with_template_sale_whscode');

    saleTypeSelect.on('change', e => {
        if (e.target.value === WEB_SALE_TYPE_LABEL) {
            socialNameSelect.val('TEA_WEB');
            // Because this event changes the socialNameSelect, the Ajax must be triggered here too.
            saleroomAjax(socialNameSelect);
        }
    });
}

/**
 * Allow to put default value and disabled or not the buyer price code input depending on the sale type.
 */
global.handleBuyerPriceCodeInput = () => {
    let saleTypeSelect = $('#sale_with_template_sale_venteClassiqueOuElectronique');
    let buyerPriceCodeSelect = $('#sale_with_template_sale_codeTarifAcheteur');
    if (saleTypeSelect.val() === WEB_SALE_TYPE_LABEL) {
        buyerPriceCodeSelect.val('51');
        //buyerPriceCodeSelect.attr('readonly', 'readonly');
        //$('#sale_with_template_sale_codeTarifAcheteur option').prop('disabled', true);
    }

    saleTypeSelect.on('change', e => {
        if (e.target.value === WEB_SALE_TYPE_LABEL) {
            buyerPriceCodeSelect.val('51');
            //buyerPriceCodeSelect.attr('readonly', 'readonly');
            //$('#sale_with_template_sale_codeTarifAcheteur option').prop('disabled', true);
        } else {
            buyerPriceCodeSelect.val('');
            //buyerPriceCodeSelect.removeAttr('readonly');
            //$('#sale_with_template_sale_codeTarifAcheteur option').prop('disabled', false);
        }
    });
}

/**
 * Ajax request which replaces the salerooms select according to the social name select value.
 * The data filter is done in SaleType.php
 *
 * @param socialNameSelect
 */
const saleroomAjax = (socialNameSelect) => {
    let saleroomsSelect = $('#sale_with_template_sale_codeSalleDeVente');
    let saleroomsSelectValue = saleroomsSelect.val();
    let form = $(this).closest('form');
    let data = {};
    data[socialNameSelect.attr('name')] = socialNameSelect.val();
    saleroomsSelect.attr('disabled', 'disabled');

    $.ajax({
        url : form.attr('action'),
        type: 'post',
        data : data,
        success: html => {
            saleroomsSelect = $('#sale_with_template_sale_codeSalleDeVente');
            let newSaleroomsSelect = $(html).find('#sale_with_template_sale_codeSalleDeVente');
            newSaleroomsSelect.val(saleroomsSelectValue);
            saleroomsSelect.replaceWith(newSaleroomsSelect);

            // This function trigger another time here because to have an effect on newSaleroomsSelect, we need to wait until the response.
            handleWarningSaveMessage();
        }
    });
}

global.handleElectronicSaleType = () => {
    let electronicSaleType = $('#sale_with_template_sale_conduiteDeLaVente');
    let transformedSaleInput = $('#sale_with_template_sale_minuteDeclenchementVenteTransformee');

    let exhibitionStartDateSaleInput = $('#sale_with_template_sale_expositionDebutLe');
    let exhibitionStartInput = $('#sale_with_template_sale_elecheuredebutexpo');
    let exhibitionStartHourInput = $('#sale_with_template_sale_elecheuredebutexpo_hour');
    let exhibitionStartMinuteInput = $('#sale_with_template_sale_elecheuredebutexpo_minute');

    let exhibitionEndDateSaleInput = $('#sale_with_template_sale_expositionFinLe');
    let exhibitionEndInput = $('#row_sale_with_template_sale_elecheurefinexpo');
    let exhibitionEndHourInput = $('#sale_with_template_sale_elecheurefinexpo_hour');
    let exhibitionEndMinuteInput = $('#sale_with_template_sale_elecheurefinexpo_minute');

    let saleStartDateSaleInput = $('#sale_with_template_sale_venteDebutLe');
    let saleStartHourInput = $('#sale_with_template_sale_elecheuredebutvente_hour');
    let saleStartMinuteInput = $('#sale_with_template_sale_elecheuredebutvente_minute');

    handleSaleDateInputReadOnlyAttribute(electronicSaleType.val());

    electronicSaleType.on('change', e => {
        handleSaleDateInputReadOnlyAttribute(e.target.value);

        // When the electronic sale type is "Soumission ouverte transformée", the value of the transformed sale input is automatically 59.
        if (parseInt(e.target.value) === 5) {
            transformedSaleInput.val(59);
        }
    });

    saleStartDateSaleInput.on('blur', () => {
        //handleSaleDateChanging();

        // Needed to handle the transformed sale input.
        handleExhibitionDateEvent(
            exhibitionStartDateSaleInput,
            exhibitionStartInput,
            exhibitionStartHourInput,
            exhibitionStartMinuteInput,
            exhibitionEndInput,
            exhibitionEndHourInput,
            exhibitionEndMinuteInput,
            exhibitionEndDateSaleInput,
        )
    });

    saleStartHourInput.add(saleStartMinuteInput).on('change', () => {
        // Before changing the values of the inputs, making those needed inputs updatable.
        //makeSaleDateInputUpdatable(exhibitionStartDateSaleInput, 'sale_with_template_sale_elecheuredebutexpo');
        //makeSaleDateInputUpdatable(exhibitionEndDateSaleInput, 'sale_with_template_sale_elecheurefinexpo');

       // if (saleStartDateSaleInput.val()) {
           // handleSaleDateChanging();
        //}

        // Needed to handle the transformed sale input.
        handleExhibitionDateEvent(
            exhibitionStartDateSaleInput,
            exhibitionStartInput,
            exhibitionStartHourInput,
            exhibitionStartMinuteInput,
            exhibitionEndInput,
            exhibitionEndHourInput,
            exhibitionEndMinuteInput,
            exhibitionEndDateSaleInput,
        )
    });
}

/**
 * Making some date inputs read only or updatable depending on the value of electronicSaleType.
 *
 * @param value : string el famoso value of electronicSaleType.
 */
const handleSaleDateInputReadOnlyAttribute = (value) => {
    let exhibitionStartDateSaleInput = $('#sale_with_template_sale_expositionDebutLe');
    let exhibitionEndDateSaleInput = $('#sale_with_template_sale_expositionFinLe');
    let saleEndDateSaleInput = $('#sale_with_template_sale_venteFinLe');

    // 4 = Soumision ouverte standard / 5 = Soumision ouverte transformée.
    if (parseInt(value) === 4 || parseInt(value) === 5) {
        // Used to reset inputs readonly / disabled attributes.
        makeSaleDateInputUpdatable(exhibitionStartDateSaleInput, 'sale_with_template_sale_elecheuredebutexpo');
        makeSaleDateInputUpdatable(exhibitionEndDateSaleInput, 'sale_with_template_sale_elecheurefinexpo');
        makeSaleDateInputUpdatable(saleEndDateSaleInput, 'sale_with_template_sale_elecheurefinvente');

        makeSaleDateInputReadOnly(exhibitionStartDateSaleInput, 'sale_with_template_sale_elecheuredebutexpo');
        makeSaleDateInputReadOnly(exhibitionEndDateSaleInput, 'sale_with_template_sale_elecheurefinexpo');
    }
    // 6 = Soumision fermée.
    else if (parseInt(value) === 6) {
        // Used to reset inputs readonly / disabled attributes.
        makeSaleDateInputUpdatable(exhibitionStartDateSaleInput, 'sale_with_template_sale_elecheuredebutexpo');
        makeSaleDateInputUpdatable(exhibitionEndDateSaleInput, 'sale_with_template_sale_elecheurefinexpo');
        makeSaleDateInputUpdatable(saleEndDateSaleInput, 'sale_with_template_sale_elecheurefinvente');

        makeSaleDateInputReadOnly(exhibitionEndDateSaleInput, 'sale_with_template_sale_elecheurefinexpo');
        makeSaleDateInputReadOnly(saleEndDateSaleInput, 'sale_with_template_sale_elecheurefinvente');
    } else {
        makeSaleDateInputUpdatable(exhibitionStartDateSaleInput, 'sale_with_template_sale_elecheuredebutexpo');
        makeSaleDateInputUpdatable(exhibitionEndDateSaleInput, 'sale_with_template_sale_elecheurefinexpo');
        makeSaleDateInputUpdatable(saleEndDateSaleInput, 'sale_with_template_sale_elecheurefinvente');
    }
}

/**
 * Main function which allows to change the value of the some date inputs.
 */
const handleSaleDateChanging = () => {
    let electronicSaleType = $('#sale_with_template_sale_conduiteDeLaVente');

    let exhibitionStartDateSaleInput = $('#sale_with_template_sale_expositionDebutLe');
    let exhibitionStartHourInput = $('#sale_with_template_sale_elecheuredebutexpo_hour');
    let exhibitionStartMinuteInput = $('#sale_with_template_sale_elecheuredebutexpo_minute');

    let exhibitionEndDateSaleInput = $('#sale_with_template_sale_expositionFinLe');
    let exhibitionEndHourInput = $('#sale_with_template_sale_elecheurefinexpo_hour');
    let exhibitionEndMinuteInput = $('#sale_with_template_sale_elecheurefinexpo_minute');

    let saleStartDateSaleInput = $('#sale_with_template_sale_venteDebutLe');
    let saleStartHourInput = $('#sale_with_template_sale_elecheuredebutvente_hour');
    let saleStartMinuteInput = $('#sale_with_template_sale_elecheuredebutvente_minute');

    let saleEndDateSaleInput = $('#sale_with_template_sale_venteFinLe');
    let saleEndHourInput = $('#sale_with_template_sale_elecheurefinvente_hour');
    let saleEndMinuteInput = $('#sale_with_template_sale_elecheurefinvente_minute');

    // Before changing the values of the inputs, making those needed inputs updatable.
    makeSaleDateInputUpdatable(exhibitionStartDateSaleInput, 'sale_with_template_sale_elecheuredebutexpo');
    makeSaleDateInputUpdatable(exhibitionEndDateSaleInput, 'sale_with_template_sale_elecheurefinexpo');
    makeSaleDateInputUpdatable(saleEndDateSaleInput, 'sale_with_template_sale_elecheurefinvente');

    // 4 = Soumision ouverte standard / 5 = Soumision ouverte transformée.
    if ((parseInt(electronicSaleType.val()) === 4 || parseInt(electronicSaleType.val()) === 5)) {
        handleMinuteOnSaleDateInputDependingOnProvidedSaleDateInput(
            exhibitionEndDateSaleInput, exhibitionEndHourInput, exhibitionEndMinuteInput,
            saleStartDateSaleInput, saleStartHourInput, saleStartMinuteInput,
            false, 1
        );

        handleMinuteOnSaleDateInputDependingOnProvidedSaleDateInput(
            exhibitionStartDateSaleInput, exhibitionStartHourInput, exhibitionStartMinuteInput,
            saleStartDateSaleInput, saleStartHourInput, saleStartMinuteInput,
            false, 2
        );

        // After the inputs has been updated, makes it read only.
        makeSaleDateInputReadOnly(exhibitionStartDateSaleInput, 'sale_with_template_sale_elecheuredebutexpo');
        makeSaleDateInputReadOnly(exhibitionEndDateSaleInput, 'sale_with_template_sale_elecheurefinexpo');
    }
    // 6 = Soumision fermée.
    else if ((parseInt(electronicSaleType.val()) === 6)) {
        handleMinuteOnSaleDateInputDependingOnProvidedSaleDateInput(
            exhibitionEndDateSaleInput, exhibitionEndHourInput, exhibitionEndMinuteInput,
            saleStartDateSaleInput, saleStartHourInput, saleStartMinuteInput,
            false, 1
        );

        handleMinuteOnSaleDateInputDependingOnProvidedSaleDateInput(
            saleEndDateSaleInput, saleEndHourInput, saleEndMinuteInput,
            saleStartDateSaleInput, saleStartHourInput, saleStartMinuteInput,
            true, 1
        );

        // After the inputs has been updated, makes it read only.
        makeSaleDateInputReadOnly(exhibitionEndDateSaleInput, 'sale_with_template_sale_elecheurefinexpo');
        makeSaleDateInputReadOnly(saleEndDateSaleInput, 'sale_with_template_sale_elecheurefinvente');
    }
}

const makeSaleDateInputReadOnly = (dateInput, timeInputAsString) => {
    dateInput.prop('readOnly', true);
    dateInput.datepicker().data('datepicker').destroy();

    $('#' + timeInputAsString + '_hour').attr('readonly', 'readonly');
    $('#' + timeInputAsString + '_hour option:not(:selected)').prop('disabled', true);

    $('#' + timeInputAsString + '_minute').attr('readonly', 'readonly');
    $('#' + timeInputAsString + '_minute option:not(:selected)').prop('disabled', true);
}

const makeSaleDateInputUpdatable = (dateInput, timeInputAsString) => {
    dateInput.prop('readOnly', false);
    dateInput.datepicker({language: 'fr'});

    $('#' + timeInputAsString + '_hour').removeAttr('readonly');
    $('#' + timeInputAsString + '_hour option').prop('disabled', false);

    $('#' + timeInputAsString + '_minute').removeAttr('readonly');
    $('#' + timeInputAsString + '_minute option').prop('disabled', false);
}

/**
 * Add or subtract a number of minutes depending on minuteAmount parameter, to a provided input according to another input date.
 * Work only in sale context. Cannot be used in another context.
 *
 * @param dateInput
 * @param hourInput
 * @param minuteInput
 * @param providedDateInput
 * @param providedHourInput
 * @param providedMinuteInput
 * @param isAnAddition : boolean
 * @param minuteAmount : number
 */
const handleMinuteOnSaleDateInputDependingOnProvidedSaleDateInput = (
    dateInput, hourInput, minuteInput,
    providedDateInput, providedHourInput, providedMinuteInput,
    isAnAddition, minuteAmount
) => {
    let value = providedDateInput.val();

    if (value) {
        let startDateTime = moment(value.substring(6, 10)+'-'+value.substring(3, 5)+'-'+value.substring(0, 2));
        startDateTime.hours(parseInt(providedHourInput.val())).minutes(parseInt(providedMinuteInput.val()));

        if (isAnAddition) {
            startDateTime.add(minuteAmount, 'minutes');
        } else {
            startDateTime.subtract(minuteAmount, 'minutes');
        }

        dateInput.datepicker().data('datepicker').selectDate(startDateTime.toDate());
        hourInput.val(startDateTime.format('H'));
        minuteInput.val(startDateTime.format('m'));
    }
}

global.handleDateInputsAccordingToSalesTypeInput = () => {
    let saleTypeSelect = $('#sale_with_template_sale_venteClassiqueOuElectronique');
    let exhibitionStartDateSaleInput = $('#sale_with_template_sale_expositionDebutLe');
    let exhibitionEndDateSaleInput = $('#sale_with_template_sale_expositionFinLe');
    let saleEndDateSaleInput = $('#sale_with_template_sale_venteFinLe');

    saleTypeSelect.change(e => {
        if (e.target.value === WEB_SALE_TYPE_LABEL) {
            handleSaleDateChanging();
        } else {
            makeSaleDateInputUpdatable(exhibitionStartDateSaleInput, 'sale_with_template_sale_elecheuredebutexpo');
            makeSaleDateInputUpdatable(exhibitionEndDateSaleInput, 'sale_with_template_sale_elecheurefinexpo');
            makeSaleDateInputUpdatable(saleEndDateSaleInput, 'sale_with_template_sale_elecheurefinvente');
        }
    })
}

global.handleWarningSaveMessage = () => {
    let saleTypeSelect = $('#sale_with_template_sale_venteClassiqueOuElectronique');
    let warningSaveMessage = $('#warning-save-message');
    let inputs = $(':input');

    if (saleTypeSelect.val() === WEB_SALE_TYPE_LABEL) {
        inputs.change(() => {
            warningSaveMessage.removeClass('d-none');
        })
    }


    saleTypeSelect.change(e => {
        if (e.target.value === WEB_SALE_TYPE_LABEL) {
            inputs.change(() => {
                warningSaveMessage.removeClass('d-none');
            })
        }
    })
}



// WEBPACK FOOTER //
// ./assets/js/sale.js